export default __webpack_public_path__ + "static/media/meeting.1c9d1141.jpg";